import { EQLFunctionName } from 'v2/core/repository/eql/types';

export function isAggregateFormula(formulaName?: string) {
  if (
    formulaName === EQLFunctionName.NPS ||
    formulaName === EQLFunctionName.CSAT ||
    formulaName === EQLFunctionName.Mean ||
    formulaName === EQLFunctionName.Sum
  ) {
    return true;
  }

  return false;
}
